import { useEffect, useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

type State = "checking" | "authed" | "unauthed";

type CustomerInfo = {
  id: string;
  email: string;
  brandRegistry?: boolean;
  collaboratorStatus?: "none" | "invite_sent" | "verified";
  inviteSentAt?: string | null;
  verifiedAt?: string | null;
};

export function CustomerGate({
  children,
}: {
  children: (customer: CustomerInfo) => ReactNode;
}) {
  const [state, setState] = useState<State>("checking");
  const [customer, setCustomer] = useState<CustomerInfo | null>(null);

  useEffect(() => {
    let cancelled = false;
    api<{ customer: CustomerInfo }>("/customer/me").then((res) => {
      if (cancelled) return;
      if (res.ok && res.data?.customer) {
        setCustomer(res.data.customer);
        setState("authed");
      } else {
        setState("unauthed");
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === "checking") {
    return (
      <div className="flex items-center justify-center p-12 text-slate-600">
        <Loader2 className="h-5 w-5 animate-spin" />
      </div>
    );
  }
  if (state === "unauthed" || !customer) {
    return <Navigate to="/login" replace />;
  }
  return <>{children(customer)}</>;
}
